// Both throw when the API responds with a non-2xx status (e.g. 503 when Google
// is unavailable) so callers can fall back to manual address input.

export async function getGooglePlacesClientSide({
  search,
}: {
  search: string
}) {
  const res = await fetch("/api/google/places-autocomplete", {
    method: "POST",
    body: JSON.stringify({ search }),
  })
  if (!res.ok) throw new Error(`places-autocomplete failed: ${res.status}`)

  return await res.json()
}

export async function getGooglePlaceDetailsClientSide({
  place_id,
}: {
  place_id: string
}) {
  const res = await fetch("/api/google/place-details", {
    method: "POST",
    body: JSON.stringify({ place_id }),
  })
  if (!res.ok) throw new Error(`place-details failed: ${res.status}`)

  return await res.json()
}
